var $50b6ed0722158ec0$exports = {};
$50b6ed0722158ec0$exports = {
    "info": `\u{60C5}\u{5831}`,
    "negative": `\u{30A8}\u{30E9}\u{30FC}`,
    "positive": `\u{6210}\u{529F}`
};


export {$50b6ed0722158ec0$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
